import { Link } from 'react-router-dom';

export default function StripeSuccess() {
  return (
    <section className="mb-3">
      <div className="container">
        <div className="row d-flex align-items-center my-5">
          <div className="col-11 col-lg-6 mx-auto text-center">
            <div className="card shadow border-0 p-5">
              <div className="mb-4">
                <i
                  className="bi bi-check-circle-fill text-success"
                  style={{ fontSize: '70px' }}
                ></i>
              </div>

              <h2 className="mb-3">Compte Stripe confirmé 🎉</h2>

              <p className="text-muted">
                Votre compte de paiement a été configuré avec succès.
                <br />
                Vous pouvez désormais recevoir des paiements sur la plateforme.
              </p>

              <div className="alert alert-success mt-3">Votre profil de paiement est actif.</div>

              <div className="mt-4 d-flex gap-3 justify-content-center">
                <Link to="/guest/settings" className="btn btn-primary btn-lg">
                  Accèder au paramètres
                </Link>

                <Link to="/" className="btn btn-warning btn-lg ">
                  Retour à l'accueil
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
